var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-group"},_vm._l((_vm.displayItems),function(item){return _c('app-dashboard-item',{key:item.name,attrs:{"item":item},on:{"setSetpoint":_vm.setSetpoint}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }